import React, { Component } from 'react';
import 'bootstrap/less/bootstrap.less';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';

import Register from './Register';
import SignInPage from './SignIn'
import View from './View';

import withAuthentication from './withAuthentication';

class App extends Component {

  render() {
    return (
      <Router>
        <div>
          <Route
            exact path='/register'
            component={() => <Register />}
          />
          <Route
            exact path='/view'
            component={() => <View />}
          />
          <Route path='/signin'
            component={() => <SignInPage />}
          />
          <Route exact path="/" render={() => (
            <Redirect to="/register"/>
          )}/>
        </div>
      </Router>
    );
  }
}

export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/components/App.js